import { fetchFromApi } from '../../helpers/api';

export const ProfileActionTypes = {
  GET_PROFILE_REQUEST: 'PROFILE/GET_PROFILE_REQUEST',
  GET_PROFILE_SUCCESS: 'PROFILE/GET_PROFILE_SUCCESS',
  GET_PROFILE_FAILURE: 'PROFILE/GET_PROFILE_FAILURE',

  UPDATE_PROFILE_REQUEST: 'PROFILE/UPDATE_PROFILE_REQUEST',
  UPDATE_PROFILE_SUCCESS: 'PROFILE/UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAILURE: 'PROFILE/UPDATE_PROFILE_FAILURE'
};

export const getProfile = () => {
  const headers = new Headers();

  const init = {
    method: 'GET',
    headers
  };

  return {
    types: [
      ProfileActionTypes.GET_PROFILE_REQUEST,
      ProfileActionTypes.GET_PROFILE_SUCCESS,
      ProfileActionTypes.GET_PROFILE_FAILURE
    ],
    shouldCallApi: state => state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi('client-api/profile/', init, dispatch)
  };
};

export const updateProfile = formData => {
  const payload = new FormData();

  Object.keys(formData).map(key => {
    return payload.append(key, formData[key]);
  });

  const init = {
    method: 'POST',
    body: payload
  };

  return {
    types: [
      ProfileActionTypes.UPDATE_PROFILE_REQUEST,
      ProfileActionTypes.UPDATE_PROFILE_SUCCESS,
      ProfileActionTypes.UPDATE_PROFILE_FAILURE
    ],
    shouldCallApi: state => state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi('client-api/profile/', init, dispatch)
  };
};



/** WEBPACK FOOTER **
 ** ./src/state/profile/actions.js
 **/